import Navbar from './../Components/NavBar/NavBar'
import { User, Crown, Zap, Map, RotateCcw, Infinity } from 'lucide-react'
import { BMC_PRICING } from '../utils/appConstants'

export default function BMC() {
  return (
    <div className="min-h-screen bg-base-200 w-screen flex justify-center items-center">
      <Navbar page="loginPage" />

      <div className="container mx-auto px-4 py-12">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-base-content mb-4">Choose Your Plan</h1>
          <p className="text-lg text-base-content/70">Select the perfect plan for your roadmap creation needs</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {/* Normal User Card */}
          <div className="card bg-base-100 shadow-xl border border-base-300 hover:shadow-2xl transition-shadow duration-300">
            <div className="card-body">
              <div className="flex items-center justify-center mb-4">
                <div className="bg-primary/10 p-3 rounded-full">
                  <User className="w-8 h-8 text-primary" />
                </div>
              </div>
              <h2 className="card-title text-2xl font-bold text-center justify-center text-base-content">
                Normal User
              </h2>
              <div className="text-center mb-6">
                <span className="text-4xl font-bold text-primary">Free</span>
              </div>

              <div className="space-y-4">
                <div className="flex items-center gap-3">
                  <Map className="w-5 h-5 text-success" />
                  <span className="text-base-content">2 Roadmaps Available</span>
                </div>
                <div className="flex items-center gap-3">
                  <RotateCcw className="w-5 h-5 text-success" />
                  <span className="text-base-content">5 Creation Attempts</span>
                </div>
                <div className="flex items-center gap-3">
                  <User className="w-5 h-5 text-success" />
                  <span className="text-base-content">Basic Features</span>
                </div>
              </div>

              <div className="card-actions justify-center mt-8">
                <button className="btn btn-primary btn-wide">Get Started</button>
              </div>
            </div>
          </div>

          {/* Premium User Card */}
          <div className="card bg-base-100 shadow-xl border-2 border-secondary hover:shadow-2xl transition-shadow duration-300 relative">
            <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
              <div className="bg-secondary text-secondary-content px-4 py-1 rounded-full text-sm font-medium">
                Popular
              </div>
            </div>
            <div className="card-body">
              <div className="flex items-center justify-center mb-4">
                <div className="bg-secondary/10 p-3 rounded-full">
                  <Crown className="w-8 h-8 text-secondary" />
                </div>
              </div>
              <h2 className="card-title text-2xl font-bold text-center justify-center text-base-content">
                Premium User
              </h2>
              <div className="text-center mb-6">
                <span className="text-4xl font-bold text-secondary">₹ {BMC_PRICING.PREMIUM.AMOUNT}</span>
                <span className="text-base-content/70">/month</span>
              </div>

              <div className="space-y-4">
                <div className="flex items-center gap-3">
                  <Map className="w-5 h-5 text-success" />
                  <span className="text-base-content">10 Roadmaps Available</span>
                </div>
                <div className="flex items-center gap-3">
                  <RotateCcw className="w-5 h-5 text-success" />
                  <span className="text-base-content">20 Creation Attempts</span>
                </div>
                <div className="flex items-center gap-3">
                  <Crown className="w-5 h-5 text-success" />
                  <span className="text-base-content">Advanced Features</span>
                </div>
                <div className="flex items-center gap-3">
                  <Zap className="w-5 h-5 text-success" />
                  <span className="text-base-content">Priority Support</span>
                </div>
              </div>

              <div className="card-actions justify-center mt-8">
                <button className="btn btn-secondary btn-wide" onClick={() => window.location.href = `${BMC_PRICING.PREMIUM.LINK}`}>Upgrade Now</button>
              </div>
            </div>
          </div>

          {/* Premium Plus Card */}
          <div className="card bg-base-100 shadow-xl border border-accent hover:shadow-2xl transition-shadow duration-300">
            <div className="card-body">
              <div className="flex items-center justify-center mb-4">
                <div className="bg-accent/10 p-3 rounded-full">
                  <Zap className="w-8 h-8 text-accent" />
                </div>
              </div>
              <h2 className="card-title text-2xl font-bold text-center justify-center text-base-content">
                Premium Plus
              </h2>
              <div className="text-center mb-6">
                <span className="text-4xl font-bold text-accent">₹ {BMC_PRICING.PREMIUM_PLUS.AMOUNT}</span>
                <span className="text-base-content/70">/month</span>
              </div>

              <div className="space-y-4">
                <div className="flex items-center gap-3">
                  <Map className="w-5 h-5 text-success" />
                  <span className="text-base-content">50 Roadmaps Available</span>
                </div>
                <div className="flex items-center gap-3">
                  <Infinity className="w-5 h-5 text-success" />
                  <span className="text-base-content">Unlimited Attempts</span>
                </div>
                <div className="flex items-center gap-3">
                  <Zap className="w-5 h-5 text-success" />
                  <span className="text-base-content">All Premium Features</span>
                </div>
                <div className="flex items-center gap-3">
                  <Crown className="w-5 h-5 text-success" />
                  <span className="text-base-content">VIP Support</span>
                </div>
              </div>

              <div className="card-actions justify-center mt-8">
                <button className="btn btn-accent btn-wide" onClick={() => window.location.href = `${BMC_PRICING.PREMIUM_PLUS.LINK}`}>Go Premium Plus</button>
              </div>
            </div>
          </div>
        </div>

        <div className="text-center mt-12">
          <p className="text-base-content/70">All plans include secure payment processing and can be cancelled anytime.</p>
        </div>
      </div>
    </div>
  )
}